export default __webpack_public_path__ + "locales/az/Payments.json?hash=186c2c732c3606b9f4a8376966baafac";